<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <p class="title">Manual Conversion</p>
        <v-form ref="form" style="width: 100%;display: flex;">
          <v-flex xs2>
          <v-text-field
            type="number"
            v-model="networkUrlId"
            label="Network Url Id"
          ></v-text-field>
          </v-flex>
          <v-flex xs2>
          <v-text-field
            v-model="pubId"
            label="Publisher Id"
          ></v-text-field>
          </v-flex>
          <v-flex xs2>
          <v-text-field
            type="number"
            v-model="hour"
            label="Click Hour"
          ></v-text-field>
          </v-flex>
          <v-flex xs2>
          <v-text-field
            type="number"
            v-model="count"
            label="No of Convertion"
          ></v-text-field>
          </v-flex>
          <v-flex xs4>
          
          <v-btn v-if="!showProgress" color="primary" @click="submit">
            Send
          </v-btn>
          <v-progress-circular
            v-else
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn @click="clear">clear</v-btn>

          
          </v-flex>

        </v-form>
      </v-layout>
    </v-container>

    

    <v-layout style="margin-top: 20px;">
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="affectedClicks"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.serialNumber }}</td>
              <td class="text-xs-left">{{ props.item.clickId }}</td>
              <td class="text-xs-left">{{ props.item.networkUrlId }}</td>
              <td class="text-xs-left">{{ props.item.publisherId }}</td>
              <td class="text-xs-left">{{ props.item.formatedTime }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center pt-2">
      <v-btn color="primary" @click.native="loadManualConversionList()">Today's Manual Conversions</v-btn>
    </div>

    <div v-if="showTodaysConversion">
      <v-layout style="margin-top: 20px;">
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="todaysManualConversion"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.serialNumber }}</td>
              <td class="text-xs-left">{{ props.item.clickId }}</td>
              <td class="text-xs-left">{{ props.item.networkUrlId }}</td>
              <td class="text-xs-left">{{ props.item.publisherId }}</td>
              <td class="text-xs-left">{{ props.item.formatedTime }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    </div>


    </div>
</template>

<script>

import axios from 'axios'
import { SERVER_URL } from './../../constant.js'

export default {
  data() {
    return {
      count: null,
      hour: null,
      networkUrlId: null,
      pubId: null,
      affectedClicks: [],
      headers: [
        {
          text: "S. No.",
          value: "serialNumber",
          align: "left",
          sortable: false
        },
        {
          text: "clickId",
          value: "clickId",
          align: "left",
          sortable: false
        },
        {
          text: "NetworkUrlId",
          value: "networkUrlId",
          align: "left",
          sortable: false
        },
        {
          text: "PublisherId",
          value: "PublisherId",
          align: "left",
          sortable: false
        },
        {
          text: "Time",
          value: "timestmap",
          align: "left",
          sortable: false
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      showResult: false,
      showProgress: false,

      showTodaysConversion: false,
      todaysManualConversion: []
    }
  },
  created () {
    document.title = 'mannual postback';
  },
  methods: {
    submit() {
      if (this.networkUrlId && this.count <= 10 && this.count > 0) {
        this.showProgress = true;
        let vm = this;
        let url  = `${SERVER_URL}/network/manual/postback?offerId=${vm.networkUrlId}&count=${vm.count}`;
        if (vm.pubId) url = url + `&pubId=${vm.pubId}`;
        if (vm.hour) url = url + `&hour=${vm.hour}`;
        axios.get(url)
        .then(res => {

          vm.showProgress = false;
          // vm.$refs.form.reset();

          if (res.data && res.data.length) {
            let showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Conversion sent Successfully'})
            document.dispatchEvent(showSnackbarEvent)

            //vm.affectedClicks = res.data;
            res.data.forEach((conv, indx) => {
              conv.formatedTime = vm.convertToIST(conv.clickTimestamp);
              conv.serialNumber = ++indx;
              vm.affectedClicks.push(conv)
            })
            vm.clear();
          } else {
            let showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'No click/conversion found.'})
            document.dispatchEvent(showSnackbarEvent);
            vm.clear();
          }
        })
        .catch(function(error) {
          vm.showProgress = false;
          vm.clear();
        })
      } else {
        let showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Network Url Id and count(less than 10) is mandatory.'})
        document.dispatchEvent(showSnackbarEvent)
      }
    },

    loadManualConversionList () {
      let vm = this;
      vm.todaysManualConversion.length = 0;
      let url  = `${SERVER_URL}/network/manual/all`;
      if (vm.networkUrlId) url = url + `?offerId=${vm.networkUrlId}`;
      axios.get(url)
      .then(res => {
        if (res.data && res.data.length) {
          //vm.todaysManualConversion = res.data;
          res.data.forEach((conv, indx) => {
            conv.formatedTime = vm.convertToIST(conv.clickTimestamp);
            conv.serialNumber = ++indx;
            vm.todaysManualConversion.push(conv)
          })
          vm.showTodaysConversion = true;
        } else {
          let showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'No manual click/conversion found.'})
          document.dispatchEvent(showSnackbarEvent);
        }
      })
    },
    convertToIST(timestamp) {
      let date = new Date(timestamp);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toLocaleString();
    },
    clear () {
      this.$refs.form.reset();
      this.showTodaysConversion = false;
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/network/ManualPostback.vue